import { Box, Paper, Typography, IconButton, Menu, MenuItem, Button } from '@mui/material';
import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Link } from "react-router-dom"

function CustomNode({ el }) {

    const [anchorEl, setAnchorEl] = React.useState(false);
    const open = Boolean(anchorEl);

    //Open modal
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    //Close modal
    const handleClose = () => {
        setAnchorEl(false);
    };
    return (
        <Paper sx={{ paddingTop: 2, paddingBottom: 2, paddingX: 1, maxWidth: 160 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                <Typography fontWeight={700} fontSize={13}>
                    {el.data.label}
                </Typography>
                <IconButton
                    size='small'
                    id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                    color="inherit">
                    <DragIndicatorIcon />
                </IconButton>
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                >
                    <MenuItem>
                        <Link to={`/settingsupconversationtemplate?id=${el.id}&type=edit`}>
                            <Button size='small' variant={"text"}>EDIT</Button>
                        </Link>
                    </MenuItem>
                    <MenuItem>
                        <Link to={`/settingsupconversationtemplate?id=${el.id}&type=copy`}>
                            <Button size='small' variant={"text"}>COPY</Button>
                        </Link>
                    </MenuItem>
                </Menu>
            </Box>

            <Typography fontSize={11} mb={1}>
                {el.data.descr}
            </Typography>
            <Box sx={{ background: (Math.floor(el.data.recordnumber / 1000)) % 2 === 0 ? 'green' : '#1976d2', height: 3 }} />

            <Handle type="target" position={Position.Left} className="w-16 !bg-teal-500" />
            <Handle type="source" position={Position.Right} className="w-16 !bg-teal-500" />
        </Paper>
    );
}

export default memo(CustomNode);